import { render, staticRenderFns } from "./studyRecord.vue?vue&type=template&id=f31cf1d2&scoped=true&"
import script from "./studyRecord.vue?vue&type=script&lang=js&"
export * from "./studyRecord.vue?vue&type=script&lang=js&"
import style0 from "./studyRecord.vue?vue&type=style&index=0&id=f31cf1d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31cf1d2",
  null
  
)

export default component.exports